import Vue from "vue"
import moment from "moment"
import { Formatting } from "@/util/formatting"
const dateFormat = new Formatting.DateFormatting()

Vue.filter("date", (value: moment.MomentInput) => moment(value).format("YYYY-MM-DD"))
Vue.filter("timeOfDay", (value: moment.MomentInput) => moment(value).format("HH:mm"))
Vue.filter("duration", (value: number) => dateFormat.duration(value))
